import React from 'react';
import { match } from 'ts-pattern';

import { VariantProps, legacyTextStyles } from '@eluve/components';

import { ContentEditable } from './ContentEditable';

type Size = 1 | 2 | 3 | 4 | 5;

type HeaderElement = `h${Size}`;

export interface EditableTitleProps {
  title: string;
  label?: string;
  onTitleChange: (title: string) => void;
  element?: HeaderElement;
  isReadonly?: boolean;
}

export const EditableTitle: React.FC<
  EditableTitleProps & VariantProps<typeof legacyTextStyles.heading>
> = ({
  title,
  label = 'Edit title',
  onTitleChange,
  isReadonly = false,
  size = 'xs',
  element: Component = 'h2',
}) => {
  const NameHeading = (
    <Component
      className={legacyTextStyles.heading({
        size,
        className: 'inline text-wrap',
      })}
    >
      {title}
    </Component>
  );

  return match(isReadonly)
    .with(true, () => NameHeading)
    .otherwise(() => (
      <ContentEditable editButtonLabel={label} onContentChange={onTitleChange}>
        {NameHeading}
      </ContentEditable>
    ));
};
